import React, { useEffect, useState } from 'react';
import { Button, OverlayTrigger, PopOver, message } from '@tencent/spaui';
import './index.scss';
import './orderCard.scss';
import dayjs from 'dayjs';
import { currencyFormatV2 } from 'utils/index';
// @ts-ignore
import orderStore from 'pages/orderDialog/store.js';
import dialog from 'utils/dialog';
// @ts-ignore
import OrderDialogStore from '../orderDialog/store.js';
// @ts-ignore
import AgencyListStore from './agencyListDialog/store.js';
// @ts-ignore
import AgencyListDialog from './agencyListDialog/index.jsx';
// @ts-ignore
import { ADUIT_STATUS_KV, DEMAND_TYPE_KV, TARGET_TYPE_KV } from 'pages/manage/orderSquare/constants/index.js';
import { post } from 'store/request';

// const lsitData = [
//   {
//     id: 2, // 需求id
//     tender_num: 2, // 参与服务商数量
//     type: 1, // 需求类型
//     target: 1, // 需求目标
//     target_other: 'test', // （其他）需求目标描述
//     content: 'test', // 需求详情
//     budget: 1000, // 预算
//     tender_expect_deadline: '2032-09-30 00:00:00', // 服务商投标截止时间
//     tender_expect_num: 3, // 可参与投标服务商数量，枚举值：3个、5个、7个、-1不限
//     company_name: '测试公司', // 公司名称
//     company_brand: '测试品牌', // 产品/品牌线
//     company_industry: 1234576, // 所属行业
//     company_location: '测试地址', // 公司所在地
//     contact_name: '联系人', // 联系人姓名
//     contact_telephone: '18629983885', // 联系人电话
//     contact_email: '', // 联系人邮箱
//     contact_address: '', // 联系人地址
//     user_id: 1, // 发布人用户id（个人QQ对应的user_id）
//     user_type: 1, // 发布人用户类型：广告主、SAAS服务商、广告主服务商
//     status: 0, // 需求阶段/需求状态，1-审核 2-分配 3-竞标 4-合同
//     audit_status: 2, // 审核状态： 1待审核，2审核中，3审核通过，4审核未通过  5 需求取消
//     judge_tender_at: '2022-09-21 17:34:22', // 评标结束时间
//     judge_tender_by: 80, // 评标人用户ID
//     winner_tender_id: 2, // 中标记录ID
//     contract_at: '2022-10-09 19:43:35', // 合同时间
//     contract_id: 2, // 合同ID，关联demand_contract
//     created_at: '2022-09-14 17:56:00', // 创建时间
//     updated_at: '2022-09-14 17:56:00', // 更新时间
//     if_delete: 0, // 逻辑删除字段
//     error_msg: '驳回了',
//     is_reminder: '1', // 0 不展示 1 展示 提示需求过期
//   },
// ];

// eslint-disable-next-line react/display-name
export default (): JSX.Element => {
  const [list, setList] = useState([]);

  const getData = () => {
    post('/demand/list/', {}, 'v2').then((res) => {
      setList(res);
    });
    // setList(lsitData);
  };

  const showDetail = (item: any) => {
    if (+item.audit_status === 3) {
      // 审核通过不能编辑
      OrderDialogStore.viewData(item.id);
      return;
    }
    OrderDialogStore.editData(item.id);
  };

  const showAgencyList = (item: any) => {
    AgencyListStore.openAgencyDialog(item);
  };

  const cancel = (item: any) => {
    dialog
      .confirm('确认取消需求吗？')
      .then(() => {
        post(`/demand/cancel/${item.id}`, {}, 'v2').then(() => {
          message.success('取消成功');
          getData();
        });
      })
      .catch(() => {});
  };

  useEffect(() => {
    getData();
    orderStore.setCloseEffect(getData);
    return () => orderStore.setCloseEffect(null);
  }, []);

  const status2color: any = {
    1: 'gray',
    2: 'orange',
    3: 'green',
    4: 'red',
    5: 'gray',
  };

  return (
    <>
      {list?.map((item, index) => (
        <div className="application order-card-item" key={index}>
          <div className="flex space-between">
            <div className="flex" style={{ alignItems: 'center' }}>
              <div className="title">{DEMAND_TYPE_KV[item.type]}</div>
              <div className={`status-card ${status2color[item.audit_status]}`}>
                {ADUIT_STATUS_KV[item.audit_status]}
              </div>
              {!!item.tender_num && (
                <div className="status-card green">
                  <span>已有{item.tender_num}家服务商参与</span>
                </div>
              )}
            </div>
            <div className="time">{dayjs(item.updated_at).format('YYYY-MM-DD')} 发布</div>
          </div>

          {!!item.is_reminder && (
            <div className="exceed-tip">
              <span>需求即将截止，请将合适的服务商加入竞标名单</span>
            </div>
          )}

          <div className="flex">
            <div className="order-card-info-content">
              {item.audit_status === 4 && (
                <div>
                  <span>驳回原因：</span>
                  <span style={{ fontWeight: 'bolder', color: '#ff4f40' }}>{item.error_msg}</span>
                </div>
              )}
              <div>
                <OverlayTrigger placement="top" overlay={<PopOver>{item.content}</PopOver>}>
                  <span className="break-detail">
                    需求详情：{item.content.length > 50 ? `${item.content.slice(0, 50)} ...` : item.content}
                  </span>
                </OverlayTrigger>
              </div>
              <div>
                <span>需求目标：</span>
                <span>{TARGET_TYPE_KV[item.target]}</span>
              </div>
              <div className="money">¥{currencyFormatV2(item.budget, false)}</div>
            </div>
            <div className="jump-detail">
              {!!item.tender_num && (
                <Button
                  className="rect-button"
                  style={{ background: '#67c23a' }}
                  displayType="primary"
                  onClick={() => showAgencyList(item)}
                >
                  查看服务商
                </Button>
              )}
              <Button className="rect-button" displayType="primary" onClick={() => showDetail(item)}>
                {item.audit_status === 3 ? '查看需求' : '编辑需求'}
              </Button>
              {item.audit_status !== 5 && (
                <Button displayType="default" onClick={() => cancel(item)}>
                  取消需求
                </Button>
              )}
            </div>
          </div>
        </div>
      ))}
      <AgencyListDialog />
    </>
  );
};
